import React from 'react';
import { motion, useInView } from 'framer-motion';
import CountCardsContainer from '../components/counterContainer';
import PowerCard from '../components/powerCard';
import CardList from '../components/cardList';
import { cardData } from '../utiles/constant';
import { powerCards } from '../utiles/constant';

function Expertise() {
    const { inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });
    const ref = React.createRef();
    const textVariants = {
        hidden: { opacity: 0, y: -60 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <div className='px-4 sm:px-10 md:px-14 lg:px-16 xl:px-32'>
            <motion.div
                ref={ref}
                initial="hidden"
                animate={inView ? "hidden" : "visible"}
                variants={textVariants}
                transition={{ duration: 2, ease: 'easeOut' }}
                className='flex flex-col items-center justify-center text-center mb-4 mt-8 py-5'
            >
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-primary">My Expertise</h1>
                <p className="text-sm sm:text-base md:text-lg lg:text-base max-w-2xl text-gray-500">
                Turning your creative vision into compelling narratives that enchant clients and elevate your agency’s success.             </p>
            </motion.div>
            <div className="mt-8 mx-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                <motion.img
                    ref={ref}
                    src={require('../assets/images/s1.svg').default} 
                    alt='loading'
                    className="md:h-[520px] sm:h-[560px] lg:h-[600px] xl:h-[550px] xl:w-[580px] object-fill w-[700px] mt-2 rounded-3xl"
                    initial={{ x: "-90%" }}
                    animate={{ x: inView ? "-90%" : 0 }}
                    transition={{ duration: 1 }}
                />
                <div className="bg-white p-6">
                    <h2 className="text-sm sm:text-sm md:text-sm lg:text-base font-bold text-blue-500  mb-4">Who I'm </h2>
                    <h2 className="text-xl sm:text-xl md:text-2xl lg:text-4xl font-sans font-bold text-primary leading-tight mb-6">
                    Welcome to My Portfolio, where creativity meets expertise.
                    </h2>
                    <p className="text-sm sm:text-base md:text-sm lg:text-base text-gray-500 leading-relaxed mb-4">
                    I am a passionate developer on a mission to transform visions into reality. With creativity as my compass, I specialize in empowering businesses of every size to not just meet but exceed their goals.</p>
                    <p className="text-sm sm:text-base md:text-sm lg:text-base text-gray-500 leading-relaxed mb-0">
                    From startups to established enterprises, I tailor my strategies to fit every need, ensuring that each client’s journey is not only successful but transformative. I am dedicated to unleashing your potential, elevating your success, and crafting experiences that leave a lasting impact in your industry.
                    </p>
                </div>
            </div>
        
            <CountCardsContainer />
            <div className="text-center mb-12 mt-10 px-2 md:mx-8">
                <h3 className="text-lg md:text-xl font-bold text-blue-500 mb-2">Power</h3>
                <p className="text-2xl md:text-4xl font-bold text-primary mb-6">The fire that fuels my passion</p>
                <p className="text-sm md:text-sm lg:text-base text-gray-500 max-w-4xl mx-auto">
                    My IT consulting process is a structured journey through four key stages: Discovery and Analysis, Strategic Planning, Implementation and Execution, and Continuous Monitoring and Optimization.
                </p>
            </div>
            <div className="mt-8 mb-8 mx-auto flex-wrap gap-6 justify-center sm:px-1 md:px-5 lg:px-10 xl:px-12 grid sm:grid-cols-1 md:grid-cols-2">
                {powerCards.map((card, index) => (
                    <PowerCard
                        key={index}
                        direction={card.direction}
                        number={card.number}
                        title={card.title}
                        description={card.description}
                        delay={card.delay}
                    />
                ))}
            </div>
            <div className="lg:flex flex-wrap gap-x-6 px-1 mt-12 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
            <div className="flex-1 min-w-[300px] lg:w-1/2 sticky-none z-0 transition-colors lg:sticky top-0 self-start">
            <h3 className="text-lg sm:text-base md:text-base lg:text-xl font-bold text-blue-500 mb-3">
            Expertise
          </h3>
                    <div className="text-xl sm:text-xl md:text-2xl lg:text-4xl text-primary font-bold mb-4">Why Choose Me
                    </div>
                    <div className="text-sm sm:text-sm md:text-sm lg:text-lg text-gray-500">
                        <p>I am a passionate developer who thrives on creativity’s spark. My mission? To help creative professionals build a powerful online presence that not only highlights their work but also tells their unique story with impact and flair.</p>
                    </div>
                </div>
                    <CardList data={cardData} />
                </div>
            </div>
            
    );
}

export default Expertise